let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dVQR6")).then(() => parcelRequire('91IX3'));